import { cloneArray } from 'src/app/app.component';
import { UntypedFormControl } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { sortListSeq } from 'src/app/controls/functions/shared-functions';

@Component({
  selector: 'app-list-popup',
  templateUrl: './list-popup.component.html',
  styleUrls: ['./list-popup.component.scss']
})
export class ListPopupComponent implements OnInit {
  hidden_cols = [];
  visible_cols = [];
  @Input() options;
  @Input() result
  available_search = new UntypedFormControl();
  selected_search = new UntypedFormControl();
  delayed_keyword: any;
  avl_filtered_options: any = [];
  selected_filtered_options: any = [];
  avl_options: any = [];
  selected_options: any = []
  title_property = 'currencySymbol';
  id_property = 'currencyId';
  master_data: any = {}
  selected_options_code: any = [];
  selected_options_title: any = [];
  suffix_btn_icon;
  suffix_btn_label;
  header_title = "Choose options";
  avl_title = 'SELECT.available';
  selected_title = 'SELECT.selected';
  new_entry;
  addFunc;
  enable_sorting;
  steps: any = []
  current_step = 0;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog_ref: MatDialogRef<ListPopupComponent>,
    private change_detector: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.avl_options = this.data.list;
      this.avl_filtered_options = cloneArray(this.data.list);
      this.id_property = this.data.id_property;
      this.title_property = this.data.title_property;
    }
    // this.loadMastersWithDetails()
    // this.parseData();
  }


  parseData() {
    if (this.data && this.data.steps && this.data.steps.length) {
      this.steps = this.data.steps;
      this.current_step = 0;
      this.selectStep(this.steps[0], 0);
    }
    else {
      if (this.data) {
        this.id_property = this.data.id_property;
        this.title_property = this.data.title_property;
        this.avl_options = cloneArray(this.data.options)
        this.avl_filtered_options = this.data.options;
        this.avl_title = this.data.avl_title;
        this.selected_title = this.data.selected_title;
        this.header_title = this.data.header_title;
        this.addFunc = this.data.addFunc;
        this.new_entry = this.data.new_entry;
        this.suffix_btn_icon = this.data.suffix_btn_icon;
        this.suffix_btn_label = this.data.suffix_btn_label;
        this.enable_sorting = this.data.enable_sorting;
        if (typeof this.data.data == 'string') {
          this.data.data = JSON.parse(this.data.data)
          if (this.data.data.length) {
            let op = [];
            this.data.data.forEach(data => {
              this.avl_options.forEach(option => {
                if (option[this.id_property] == data) {
                  op.push(option);
                }
              })
            })
            this.removeSelected(op, 1)
            this.selected_filtered_options = cloneArray(op);
          }
          else {
            this.selected_filtered_options = [];
          }
        }
        else {
          if (this.data.data.length) {
            let op = [];
            this.data.data.forEach(data => {
              this.avl_options.forEach(option => {
                if (option[this.id_property] == data) {
                  op.push(option);
                }
              })
            })
            op = (op.filter((v, i) => op.findIndex(item => item[this.id_property] == v[this.id_property]) === i))
            this.removeSelected(op, 1)
            this.selected_filtered_options = cloneArray(op);
          }
          else {
            this.selected_filtered_options = [];
          }
        }
      }
    }

  }

  selectStep(data, index) {
    this.current_step = index;
    if (data) {
      this.id_property = data.id_property;
      this.title_property = data.title_property;
      this.avl_options = cloneArray(data.options)
      this.avl_filtered_options = cloneArray(data.options);
      this.avl_title = data.avl_title;
      this.selected_title = data.selected_title;
      this.header_title = data.header_title;
      this.addFunc = data.addFunc;
      this.new_entry = data.new_entry;
      this.suffix_btn_icon = data.suffix_btn_icon;
      this.suffix_btn_label = data.suffix_btn_label;
      this.enable_sorting = data.enable_sorting;
      if (typeof data.data == 'string') {
        data.data = JSON.parse(data.data)
        if (data.data.length) {
          let op = [];
          data.data.forEach(data => {
            this.avl_options.forEach(option => {
              if (option[this.id_property] == data) {
                op.push(option);
              }
            })
          })
          this.removeSelected(op, 1)
          this.selected_filtered_options = cloneArray(op);
        }
        else {
          this.selected_filtered_options = [];
        }
      }
      else {
        if (data.data.length) {
          let op = [];
          data.data.forEach(data => {
            this.avl_options.forEach(option => {
              if (option[this.id_property] == data) {
                op.push(option);
              }
            })
          })
          op = (op.filter((v, i) => op.findIndex(item => item[this.id_property] == v[this.id_property]) === i))
          this.removeSelected(op, 1)
          this.selected_filtered_options = cloneArray(op);
        }
        else {
          this.selected_filtered_options = [];
        }
      }
      if (data.relation_id && data.relation_key && this.steps && this.steps.length) {
        let index = this.steps.findIndex(step => step.id == data.relation_id);
        if (index > -1) {
          let prev_step = this.steps[index];
          if (prev_step && prev_step.temp_filtered_options && prev_step.temp_filtered_options.length && this.avl_options && this.avl_options.length) {
            let new_reqs = []
            prev_step.temp_filtered_options.forEach(filtered_op => {
              let ix = this.avl_options.filter(avl_op => avl_op[data.relation_key] == filtered_op[data.relation_key])
              if (new_reqs && new_reqs.length) {
                if (ix && ix.length) {
                  new_reqs = [...new_reqs, ...ix];
                }

              }
              else {
                new_reqs = ix;
              }

            })

            this.avl_filtered_options = new_reqs;
            this.avl_options = new_reqs;
            this.removeSelected(this.selected_filtered_options, 1);
          }
        }
      }

    }
  }
  parseDataChanges(data) {
    if (data) {
      if (data.options) {
        this.avl_options = cloneArray(data.options)
        this.avl_filtered_options = data.options;
      }
      if (data.data) {
        if (typeof data.data == 'string') {
          data.data = JSON.parse(data.data)
          if (data.data.length) {
            let op = [];
            data.data.forEach(data => {
              this.avl_options.forEach(option => {
                if (option[this.id_property] == data) {
                  op.push(option);
                }
              })
            })
            this.removeSelected(op, 1)
            this.selected_filtered_options = cloneArray(op);
          }
          else {
            this.selected_filtered_options = [];
          }
        }
        else {
          if (data.data.length) {
            let op = [];
            data.data.forEach(data => {
              this.avl_options.forEach(option => {
                if (option[this.id_property] == data) {
                  op.push(option);
                }
              })
            })
            op = (op.filter((v, i) => op.findIndex(item => item[this.id_property] == v[this.id_property]) === i))
            this.removeSelected(op, 1)
            this.selected_filtered_options = cloneArray(op);
          }
          else {
            this.selected_filtered_options = [];
          }
        }
      }

    }

  }
  actionClicked(option, new_flag?) {
    if (this.addFunc) {
      try {
        this.addFunc(option, new_flag);
      }
      catch (err) {
        console.log(err)
      }
    }
  }
  availableFilter(event?) {
    // this.showList(event);
    let filter = this.available_search && this.available_search.value ? this.available_search.value.toLowerCase() : '';
    if (filter) {
      this.avl_filtered_options = [];
      for (let i = 0; i < this.avl_options.length; i++) {
        let option = this.avl_options[i];
        if (option && option[this.title_property]) {
          if (option[this.title_property].toLowerCase().indexOf(filter) > -1) {
            this.avl_filtered_options.push(option);
          }
        }
      }
      this.avl_filtered_options = cloneArray(this.avl_filtered_options);
    }
    else {
      this.avl_filtered_options = this.avl_options;
    }
    this.change_detector.detectChanges();
  }
  selectedFilter(event?) {
    let filter = this.selected_search && this.selected_search.value ? this.selected_search.value.toLowerCase() : '';
    this.delayed_keyword = filter;

    if (filter) {
      this.selected_filtered_options = [];
      for (let i = 0; i < this.selected_options.length; i++) {
        let option = this.selected_options[i];
        if (option && option[this.title_property]) {
          if (option[this.title_property].toLowerCase().indexOf(filter) > -1) {
            this.selected_filtered_options.push(option);
          }
        }
      }
    }
    else {
      this.selected_filtered_options = this.selected_options;
    }
    this.change_detector.detectChanges();
  }

  onSelect(selected_option, index, flag) {
    this.dialog_ref.close({
      option: selected_option,
      index: index
    })
  }

  selectAvailableData() {
    let options = []
    if (this.avl_filtered_options) {
      this.avl_filtered_options.forEach(a => {
        if (a.option_selected) {
          a.option_selected = false;
          options.push(a);
        }
      })
      let data = cloneArray(options)
      this.removeSelected(data, 1);
      this.selected_filtered_options = [...this.selected_filtered_options, ...data];
      this.selected_filtered_options = cloneArray(this.selected_filtered_options);
      this.selected_filtered_options = this.selected_filtered_options.sort((a, b) => a[this.title_property].localeCompare(b[this.title_property]));
      this.selected_filtered_options = (this.selected_filtered_options.filter((v, i) => this.selected_filtered_options.findIndex(item => item[this.id_property] == v[this.id_property]) === i))
      this.selected_options = cloneArray(this.selected_filtered_options);
    }
  }

  selectAllAvailable() {
    this.avl_filtered_options.forEach(a => {
      a.option_selected = false;
    })
    this.selected_filtered_options = [...this.selected_filtered_options, ...cloneArray(this.avl_filtered_options)];
    this.selected_filtered_options = this.selected_filtered_options.sort((a, b) => a[this.title_property].localeCompare(b[this.title_property]));
    this.selected_filtered_options = (this.selected_filtered_options.filter((v, i) => this.selected_filtered_options.findIndex(item => item[this.id_property] == v[this.id_property]) === i))
    this.selected_options = cloneArray(this.selected_filtered_options);
    this.avl_filtered_options = [...[]];
  }

  deleteAllSelected() {
    this.selected_filtered_options.forEach(a => {
      a.option_selected = false;
    })
    this.avl_filtered_options = [...this.avl_filtered_options, ...cloneArray(this.selected_filtered_options)];
    this.avl_filtered_options = this.avl_filtered_options.sort((a, b) => a[this.title_property].localeCompare(b[this.title_property]));
    this.avl_filtered_options = (this.avl_filtered_options.filter((v, i) => this.avl_filtered_options.findIndex(item => item[this.id_property] == v[this.id_property]) === i))
    this.avl_options = this.avl_filtered_options;
    this.selected_filtered_options = [...[]];
  }
  deleteSelectedData() {
    let options = []
    if (this.selected_filtered_options) {
      this.selected_filtered_options.forEach(a => {
        if (a.option_selected) {
          a.option_selected = false;
          options.push(a);
        }
      })
      let data = cloneArray(options)
      this.removeSelected(data, 2);
      this.avl_filtered_options = [...this.avl_filtered_options, ...data];
      this.avl_filtered_options = cloneArray(this.avl_filtered_options);
      this.avl_filtered_options = this.avl_filtered_options.sort((a, b) => a[this.title_property].localeCompare(b[this.title_property]));
      this.avl_filtered_options = (this.avl_filtered_options.filter((v, i) => this.avl_filtered_options.findIndex(item => item[this.id_property] == v[this.id_property]) === i))
      this.avl_options = cloneArray(this.avl_filtered_options);
    }
  }

  removeSelected(options, flag) {
    if (flag == 1) {
      options.forEach(o => {
        let index = this.avl_filtered_options.findIndex(data => data[this.id_property] == o[this.id_property]
        )
        if (index > -1) {
          this.avl_filtered_options.splice(index, 1);
        }
      })
      this.avl_filtered_options = cloneArray(this.avl_filtered_options);
    }
    else if (flag == 2) {
      options.forEach(o => {
        let index = this.selected_filtered_options.findIndex(data => data[this.id_property] == o[this.id_property]
        )
        if (index > -1) {
          this.selected_filtered_options.splice(index, 1);
        }
      })
      this.selected_filtered_options = cloneArray(this.selected_filtered_options);
    }
  }
  close(flag?) {
    let options = [];
    this.avl_filtered_options.forEach(option => {
      if (option.option_selected) {
        options.push(option)
      }
    })
    if (!flag) {
      this.dialog_ref.close()
    }
    else {
      if (this.selected_filtered_options && this.selected_filtered_options.length == 0) {
        this.dialog_ref.close(options)
      }
      else {
        this.dialog_ref.close(this.selected_filtered_options);
      }
    }
  }

  drop(event: CdkDragDrop<unknown>) {
    moveItemInArray(this.selected_filtered_options, event.previousIndex, event.currentIndex);
    this.selected_filtered_options = this.setSequence(this.selected_filtered_options, 'seq')
    this.selected_filtered_options = sortListSeq(this.selected_filtered_options, 'seq');
  }
  setSequence(array, key) {
    array.forEach((ele, i) => {
      ele[key] = i + 1;
    })

    return array;
  }

  storeCurrentStepAndSelectNext(prev?) {
    if (this.steps && this.steps.length) {
      if (!prev) {

      }
      let options = []
      if (this.avl_filtered_options && this.avl_filtered_options.length) {
        options = this.avl_filtered_options.filter(data => data.option_selected)
      }
      if (this.selected_filtered_options && this.selected_filtered_options.length == 0) {
        if (this.current_step < this.steps.length - 1 || (prev && this.current_step >= 0)) {
          this.steps[this.current_step]['data'] = options.map(data => data[this.id_property]);
          this.steps[this.current_step]['temp_filtered_options'] = options;
          if (!prev) {
            this.current_step++;
          }
          else {
            this.current_step--;
            if (this.current_step < 0) {
              this.dialog_ref.close()
            }
          }
          this.selectStep(this.steps[this.current_step], this.current_step);
        }
        else {
          this.steps[this.current_step]['data'] = options.map(data => data[this.id_property]);
          this.steps[this.current_step]['temp_filtered_options'] = options;
          if (!prev) {
            this.dialog_ref.close(this.steps)
          }
        }
      }
      else {
        if (this.current_step < this.steps.length - 1 || (prev && this.current_step >= 0)) {
          if (this.selected_filtered_options && this.selected_filtered_options.length) {
            if (this.steps[this.current_step]) {
              this.steps[this.current_step]['data'] = this.selected_filtered_options.map(data => data[this.id_property]);
              this.steps[this.current_step]['temp_filtered_options'] = this.selected_filtered_options;
            }
          }
          else {
            this.steps[this.current_step]['data'] = [];

          }
          if (!prev) {
            this.current_step++;
          }
          else {
            this.current_step--;
            if (this.current_step < 0) {
              this.dialog_ref.close()
            }
          }
          this.selectStep(this.steps[this.current_step], this.current_step);
        }
        else {
          if (this.selected_filtered_options && this.selected_filtered_options.length) {
            this.steps[this.current_step]['data'] = this.selected_filtered_options.map(data => data[this.id_property]);
            this.steps[this.current_step]['temp_filtered_options'] = this.selected_filtered_options;
          }
          else {
            this.steps[this.current_step]['data'] = [];

          }
          if (!prev) {
            this.dialog_ref.close(this.steps)
          }
        }
      }
    }
  }
  // storeCurrentStepAndSelectPrevious() {
  //   if (this.steps && this.steps.length) {
  //     let options = []
  //     if (this.avl_filtered_options && this.avl_filtered_options.length) {
  //       options = this.avl_filtered_options.filter(data => data.option_selected)
  //     }
  //     if (this.selected_filtered_options && this.selected_filtered_options.length == 0) {
  //       if (this.current_step < this.steps.length - 1) {
  //         this.steps[this.current_step].data = options;
  //         this.current_step++;
  //         this.selectStep(this.steps[this.current_step], this.current_step);
  //       }
  //       else {
  //         this.steps[this.current_step].data = options
  //         this.dialog_ref.close(this.steps)
  //       }
  //     }
  //     else {
  //       if (this.current_step < this.steps.length - 1) {
  //         this.steps[this.current_step].data = this.selected_filtered_options;
  //         this.current_step++;
  //         this.selectStep(this.steps[this.current_step], this.current_step);
  //       }
  //       else {
  //         this.steps[this.current_step].data = this.selected_filtered_options
  //         this.dialog_ref.close(this.steps)
  //       }
  //     }
  //   }
  // }

}

